export const routeNames = {
    home:"/",
    services:"/services",
    servicesDetail:"/services/:serviceId",
    specialities:"/specialities",
    specialitiesDetail:"/specialities/:specialitiesId",
    testinomials:"/testinomials",
    testinomialsDetail:"/testinomialsDetail",
    testinomialsShareYourStory:"/shareyourstory",
    Blog:"/blog",
    blogDetail:"/blog/:blogId",
    patientinfo:"/patientinfo",
    newpatientform:"/newpatientform",
    contact:"/contactus",
    aboutus:"/aboutus",
    teammemberdetail:"/teammemberdetail",
    demo:"/demo"
}